/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdvancedSearchAddress
 */
export interface AdvancedSearchAddress {
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchAddress
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchAddress
     */
    zipCode?: string;
}

/**
 * Check if a given object implements the AdvancedSearchAddress interface.
 */
export function instanceOfAdvancedSearchAddress(value: object): value is AdvancedSearchAddress {
    return true;
}

export function AdvancedSearchAddressFromJSON(json: any): AdvancedSearchAddress {
    return AdvancedSearchAddressFromJSONTyped(json, false);
}

export function AdvancedSearchAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvancedSearchAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'city': json['city'] == null ? undefined : json['city'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
    };
}

export function AdvancedSearchAddressToJSON(value?: AdvancedSearchAddress | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'city': value['city'],
        'zipCode': value['zipCode'],
    };
}

